import { GetServerSidePropsContext } from 'next';
import { signIn, useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import React from 'react';

import { routes } from '../../../routes';

import { dsoTheme, iteroTheme, resellerTheme } from '../../../theme';
import { ThemeProvider } from 'react-jss';
import {
  IBusinessUnit,
  parseCallbackUrlForBusinessUnit,
} from '../../../utils/businessUnitMappingHelpers/businessUnitMappingHelpers';
import { LoadingScreen } from '../../../components/atoms/LoadingScreen';
import { getToken } from 'next-auth/jwt';

export default function Signin({
                                 businessUnit,
                               }: {
  businessUnit: IBusinessUnit['type'] | null;
}) {
  const { query } = useRouter();
  const { status } = useSession();

  const callbackUrl = (businessUnit ? `/${businessUnit}` : '/').toString();
  const signInProvider = businessUnit ?? undefined;
  const resolvedBusinessUnit = businessUnit ?? 'dso';

  const onSignIn = React.useCallback(
      () => signIn(signInProvider, { callbackUrl }),
      [callbackUrl, signInProvider],
  );

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (status === 'unauthenticated') {
        if (!query.error) {
          onSignIn();
        }
      }
    }, 2000);

    // Cleanup function to clear the timeout if the component unmounts
    return () => {
      if (timeoutId) {
        return clearTimeout(timeoutId);
      }
    };
  }, [callbackUrl, status, onSignIn, query]);

  return (
      <ThemeProvider
          theme={
            businessUnit === 'exocad' || businessUnit === 'reseller'
              ? resellerTheme
              : businessUnit === 'itero'
                ? iteroTheme
                : dsoTheme
          }
      >
        <LoadingScreen businessUnit={resolvedBusinessUnit} />
      </ThemeProvider>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { req, query } = context;
  // Check either the query slug (normal navigation) OR the parse from query.callback(on login)
  const businessUnit = parseCallbackUrlForBusinessUnit(
      query.callbackUrl as string,
  );

  const session = await getToken({ req });
  if (session && session.uid != null) {
    return {
      redirect: {
        destination: `/error/404`,
      },
    };
  }
  if (session) {
    return {
      redirect: {
        destination: businessUnit ? `${routes.root()}/${businessUnit}` : routes.root(),
      },
    };
  }
  return {
    props: { businessUnit: businessUnit },
  };
}
